import React, { useEffect, useState } from "react";
import { chartColors } from "../../../Shared/colors";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useGetDashboardCompleteQuery } from "../../../features/employeeSlice";
import { 
  LeadsReportContainer, 
  CustomTooltip, 
  ChartSkeleton
} from "../../../Shared/ChartComponents";

const monthNames = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export const LeadsReport = ({ staff }) => {
  const { data: dashboardData, isFetching } = useGetDashboardCompleteQuery({ staffId: staff?.id });

  const [leadReport, setLeadReport] = useState([]);

  useEffect(() => {
    if (!dashboardData?.leadReport) {
      return;
    }

    const monthData = Array.from({ length: 12 }, (_, index) => ({
      name: monthNames[index],
      leads: 0,
      month: index + 1
    }));

    dashboardData.leadReport.forEach((report) => {
      const monthIndex = report.month - 1;
      if (monthIndex >= 0 && monthIndex < 12) {
        monthData[monthIndex].leads = report.TLW;
      }
    });

    setLeadReport(monthData);
  }, [dashboardData]);

  if (isFetching) {
    return <ChartSkeleton />;
  }

  return (
    <LeadsReportContainer>
      <div className="chart-header">
        <div>
          <h3 className="chart-title">Leads Report</h3>
          <p className="chart-subtitle">Monthly lead completion trends</p>
        </div>
      </div>
      
      <div style={{ width: '100%', height: '300px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={leadReport}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 20,
            }}
          >
            <defs>
              <linearGradient id="leadsGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={chartColors.primary} stopOpacity={0.3}/>
                <stop offset="95%" stopColor={chartColors.primary} stopOpacity={0.05}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis 
              dataKey="name" 
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#666' }}
            />
            <YAxis 
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#666' }}
            />
            <Tooltip 
              content={<CustomTooltip />}
              cursor={{ stroke: chartColors.primary, strokeWidth: 1, strokeDasharray: '5 5' }}
            />
            <Area
              type="monotone"
              dataKey="leads"
              stroke={chartColors.primary}
              strokeWidth={3}
              fill="url(#leadsGradient)"
              dot={{ fill: chartColors.primary, strokeWidth: 2, r: 4 }}
              activeDot={{ r: 6, stroke: chartColors.primary, strokeWidth: 2 }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </LeadsReportContainer>
  );
};

